import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { class: "navbar navbar-expand-lg shadow-sm" }
const _hoisted_2 = { class: "container-xxl" }
const _hoisted_3 = {
  id: "mainNavbar",
  class: "collapse navbar-collapse"
}
const _hoisted_4 = { class: "navbar-nav me-auto" }
const _hoisted_5 = {
  key: 0,
  class: "nav-item dropdown"
}
const _hoisted_6 = { class: "dropdown-menu" }
const _hoisted_7 = {
  key: 1,
  class: "nav-item dropdown"
}
const _hoisted_8 = { class: "dropdown-menu" }
const _hoisted_9 = {
  key: 2,
  class: "nav-item dropdown"
}
const _hoisted_10 = { class: "dropdown-menu" }
const _hoisted_11 = {
  key: 3,
  class: "nav-item"
}
const _hoisted_12 = {
  key: 4,
  class: "nav-item"
}
const _hoisted_13 = {
  key: 0,
  class: "navbar-nav me-3"
}
const _hoisted_14 = { class: "nav-item" }
const _hoisted_15 = {
  class: "nav-link text-primary fw-medium",
  href: "#"
}
const _hoisted_16 = {
  key: 1,
  class: "navbar-nav"
}

import { ref, onMounted } from "vue";
import { useRouter } from "vue-router";
import { sessionStore } from "@/stores/Session";
import { UserApiClient } from "@/client/requests";
import { useProductStore } from "@/stores/Product";
import { useAvailablePermissionsStore } from "@/stores/Permission";
import { useLicenseTemplateStore } from "@/stores/LicenseTemplate";


export default /*@__PURE__*/_defineComponent({
  __name: 'MainNav',
  setup(__props, { expose: __expose }) {

const session = sessionStore();
const router = useRouter();
const userPermissions = ref<Array<string>>([]);
const username = ref(session.session?.user?.email || "");
const apiClient = new UserApiClient();

onMounted(async () => {
  const productStore = useProductStore();
  const permissionStore = useAvailablePermissionsStore();
  const licenseTemplateStore = useLicenseTemplateStore();

  session.loadSession();
  if (session.session) {
    userPermissions.value = Object.keys(
      session.session?.user?.permissions || {}
    );

    await Promise.all([
      productStore.fetchProducts(),
      productStore.fetchProductFamilies(),
      permissionStore.fetchActivePermissions(),
      licenseTemplateStore.fetchTemplates(),
    ]);
  }
});

/**
 * Logs the user out of the application.
 * This function is asynchronous and may involve clearing user session data,
 * revoking authentication tokens, or redirecting the user to a login page.
 */
async function logout() {
  await apiClient.logout();
  session.clearSession();
  userPermissions.value = [];
  router.push("/login");
}

/**
 * Updates the state or properties of the menubar component.
 * This function is responsible for handling any changes or updates
 * required for the menubar, such as dynamic adjustments or state management.
 */
function updateMenubar() {
  if (session.session) {
    userPermissions.value = Object.keys(
      session.session?.user?.permissions || {}
    );
  } else {
    userPermissions.value = [];
  }
}

__expose({
  updateMenubar,
});

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("nav", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_router_link, {
        to: "/",
        class: "navbar-brand px-2"
      }, {
        default: _withCtx(() => _cache[0] || (_cache[0] = [
          _createTextVNode(" Gerenciador de Licenças ")
        ])),
        _: 1
      }),
      _cache[17] || (_cache[17] = _createElementVNode("button", {
        class: "navbar-toggler",
        type: "button",
        "data-bs-toggle": "collapse",
        "data-bs-target": "#mainNavbar"
      }, [
        _createElementVNode("span", { class: "navbar-toggler-icon" })
      ], -1)),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("ul", _hoisted_4, [
          (userPermissions.value.includes('license'))
            ? (_openBlock(), _createElementBlock("li", _hoisted_5, [
                _cache[6] || (_cache[6] = _createElementVNode("a", {
                  class: "nav-link dropdown-toggle",
                  href: "#",
                  role: "button",
                  "data-bs-toggle": "dropdown",
                  "aria-expanded": "false"
                }, [
                  _createElementVNode("i", { class: "bi bi-file-earmark-text" }),
                  _createTextVNode(" Ativos ")
                ], -1)),
                _createElementVNode("ul", _hoisted_6, [
                  _createElementVNode("li", null, [
                    _createVNode(_component_router_link, {
                      to: { name: 'licenses' },
                      class: "dropdown-item"
                    }, {
                      default: _withCtx(() => _cache[1] || (_cache[1] = [
                        _createTextVNode(" Ativos ")
                      ])),
                      _: 1
                    })
                  ]),
                  _createElementVNode("li", null, [
                    _createVNode(_component_router_link, {
                      to: { name: 'assetEdit' },
                      class: "dropdown-item"
                    }, {
                      default: _withCtx(() => _cache[2] || (_cache[2] = [
                        _createTextVNode(" Novo Ativo ")
                      ])),
                      _: 1
                    })
                  ]),
                  _createElementVNode("li", null, [
                    _createVNode(_component_router_link, {
                      to: { name: 'underConstruction' },
                      class: "dropdown-item"
                    }, {
                      default: _withCtx(() => _cache[3] || (_cache[3] = [
                        _createTextVNode(" Templates ")
                      ])),
                      _: 1
                    })
                  ]),
                  _createElementVNode("li", null, [
                    _createVNode(_component_router_link, {
                      to: { name: 'assetBatches' },
                      class: "dropdown-item"
                    }, {
                      default: _withCtx(() => _cache[4] || (_cache[4] = [
                        _createTextVNode(" Lotes de Ativos ")
                      ])),
                      _: 1
                    })
                  ]),
                  _createElementVNode("li", null, [
                    _createVNode(_component_router_link, {
                      to: { name: 'underConstruction' },
                      class: "dropdown-item"
                    }, {
                      default: _withCtx(() => _cache[5] || (_cache[5] = [
                        _createTextVNode(" QR Code ")
                      ])),
                      _: 1
                    })
                  ])
                ])
              ]))
            : _createCommentVNode("", true),
          (userPermissions.value.includes('permission'))
            ? (_openBlock(), _createElementBlock("li", _hoisted_7, [
                _cache[9] || (_cache[9] = _createElementVNode("a", {
                  class: "nav-link dropdown-toggle",
                  href: "#",
                  role: "button",
                  "data-bs-toggle": "dropdown",
                  "aria-expanded": "false"
                }, [
                  _createElementVNode("i", { class: "bi bi-lock" }),
                  _createTextVNode(" Permissões ")
                ], -1)),
                _createElementVNode("ul", _hoisted_8, [
                  _createElementVNode("li", null, [
                    _createVNode(_component_router_link, {
                      to: { name: 'permissions' },
                      class: "dropdown-item"
                    }, {
                      default: _withCtx(() => _cache[7] || (_cache[7] = [
                        _createTextVNode(" Permissões ")
                      ])),
                      _: 1
                    })
                  ]),
                  _createElementVNode("li", null, [
                    _createVNode(_component_router_link, {
                      to: { name: 'permissionRules' },
                      class: "dropdown-item"
                    }, {
                      default: _withCtx(() => _cache[8] || (_cache[8] = [
                        _createTextVNode(" Regras de Permissão ")
                      ])),
                      _: 1
                    })
                  ])
                ])
              ]))
            : _createCommentVNode("", true),
          (userPermissions.value.includes('product'))
            ? (_openBlock(), _createElementBlock("li", _hoisted_9, [
                _cache[12] || (_cache[12] = _createElementVNode("a", {
                  class: "nav-link dropdown-toggle",
                  href: "#",
                  role: "button",
                  "data-bs-toggle": "dropdown",
                  "aria-expanded": "false"
                }, [
                  _createElementVNode("i", { class: "bi bi-cpu" }),
                  _createTextVNode(" Produtos ")
                ], -1)),
                _createElementVNode("ul", _hoisted_10, [
                  _createElementVNode("li", null, [
                    _createVNode(_component_router_link, {
                      to: { name: 'productFamilies' },
                      class: "dropdown-item"
                    }, {
                      default: _withCtx(() => _cache[10] || (_cache[10] = [
                        _createTextVNode(" Famílias de Produtos ")
                      ])),
                      _: 1
                    })
                  ]),
                  _createElementVNode("li", null, [
                    _createVNode(_component_router_link, {
                      to: { name: 'products' },
                      class: "dropdown-item"
                    }, {
                      default: _withCtx(() => _cache[11] || (_cache[11] = [
                        _createTextVNode(" Produtos ")
                      ])),
                      _: 1
                    })
                  ])
                ])
              ]))
            : _createCommentVNode("", true),
          (userPermissions.value.includes('client'))
            ? (_openBlock(), _createElementBlock("li", _hoisted_11, [
                _createVNode(_component_router_link, {
                  to: { name: 'underConstruction' },
                  class: "nav-link"
                }, {
                  default: _withCtx(() => _cache[13] || (_cache[13] = [
                    _createElementVNode("i", { class: "bi bi-building" }, null, -1),
                    _createTextVNode(" Clientes ")
                  ])),
                  _: 1
                })
              ]))
            : _createCommentVNode("", true),
          (userPermissions.value.includes('user'))
            ? (_openBlock(), _createElementBlock("li", _hoisted_12, [
                _createVNode(_component_router_link, {
                  to: { name: 'users' },
                  class: "nav-link"
                }, {
                  default: _withCtx(() => _cache[14] || (_cache[14] = [
                    _createElementVNode("i", { class: "bi bi-person" }, null, -1),
                    _createTextVNode(" Usuários ")
                  ])),
                  _: 1
                })
              ]))
            : _createCommentVNode("", true)
        ]),
        (_unref(session).session)
          ? (_openBlock(), _createElementBlock("ul", _hoisted_13, [
              _createElementVNode("li", _hoisted_14, [
                _createElementVNode("a", _hoisted_15, [
                  _cache[15] || (_cache[15] = _createElementVNode("i", { class: "bi bi-person-fill" }, null, -1)),
                  _createTextVNode(" " + _toDisplayString(_unref(session).session.user.email), 1)
                ])
              ])
            ]))
          : _createCommentVNode("", true),
        (_unref(session).session)
          ? (_openBlock(), _createElementBlock("ul", _hoisted_16, [
              _createElementVNode("li", { class: "nav-item" }, [
                _createElementVNode("a", {
                  class: "nav-link",
                  href: "#",
                  onClick: logout
                }, _cache[16] || (_cache[16] = [
                  _createElementVNode("i", { class: "bi bi-door-open-fill" }, null, -1),
                  _createTextVNode(" Logout ")
                ]))
              ])
            ]))
          : _createCommentVNode("", true)
      ])
    ])
  ]))
}
}

})